import isEmpty from 'lodash/isEmpty';

export const requireAll = r => {
  if (isEmpty(r)) return;

  r.keys().forEach(r);
};
